var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import './style.css';
import { TOOL_TYPE } from '@syllepsis/editor';
import cls from 'classnames';
import React from 'react';
import { CustomButton } from '../../tools';
import { getGroupKey, renderMoreToolButton, renderSylButton } from '../../utils';
var ToolbarInline = /** @class */ (function (_super) {
    __extends(ToolbarInline, _super);
    function ToolbarInline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTool = function (content, depth, extra) {
            if (depth === void 0) { depth = 0; }
            switch (content.type) {
                case TOOL_TYPE.MORE: {
                    var groupKey_1 = getGroupKey(content);
                    return renderMoreToolButton({
                        editor: _this.props.editor,
                        option: _this.props.option,
                        content: content,
                        depth: depth,
                        groupKey: groupKey_1,
                        toolbarType: 'inline',
                        renderMenu: function (tools, _depth) {
                            return tools.map(function (tool) {
                                return _this.renderTool(tool, _depth + 1, {
                                    groupKey: groupKey_1,
                                    config: content.contentOption,
                                });
                            });
                        },
                    });
                }
                case TOOL_TYPE.CUSTOM: {
                    return (React.createElement(CustomButton, __assign({ key: "custom-" + content.name }, content, { editor: _this.props.editor })));
                }
                default:
                    return renderSylButton({
                        editor: _this.props.editor,
                        option: _this.props.option,
                        activeFormat: _this.props.activeFormat,
                        content: content,
                        depth: depth,
                        toolbarType: 'inline',
                        extra: extra,
                    });
            }
        };
        return _this;
    }
    ToolbarInline.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, visible = _b.visible, editor = _b.editor, toolbarLib = _b.toolbarLib, option = _b.option;
        var contents = toolbarLib.contents;
        var _c = option.className, className = _c === void 0 ? '' : _c;
        return (React.createElement("div", { className: cls('syl-toolbar-inline', (_a = {},
                _a[className] = className,
                _a.visible = visible,
                _a)), onClick: function (e) { return !e.cancelable && editor.focus(); } }, contents.map(function (content) { return _this.renderTool(content); })));
    };
    return ToolbarInline;
}(React.Component));
export { ToolbarInline };
//# sourceMappingURL=index.js.map